export const menuItemDataIdPrefix = "dynamic-tag-menu-item-"

export const menuDataId = "dynamic-tags-menu"
